import axios from "axios";

export function getErrorMessage(error) {
  let errorMessage = "An unexpected error occurred. Please try again.";

  if (axios.isAxiosError(error) && error.response) {
    errorMessage = error.response.data?.message || errorMessage;
  } else if (error instanceof Error) {
    errorMessage = error.message;
  }

  return errorMessage;
}
